export default {
  namespaced: true,

  state: {
    ivrActive: false,
    ivrLoaded: false,
    currentCall: null,
    currentCallUsedInPolicy: false,
  },

  mutations: {
    SET_CURRENT_CALL(state, call) {
      state.currentCall = call;
    },

    SET_IVR_ACTIVE(state, isActive) {
      state.ivrActive = isActive;
    },

    SET_IVR_LOADED(state, isLoaded) {
      state.ivrLoaded = isLoaded;
    },

    SET_CURRENT_CALL_USED_IN_POLICY(state, isUsed) {
      state.currentCallUsedInPolicy = isUsed;
    },

    RESET_STATE(state) {
      state.ivrActive = false;
      state.ivrLoaded = false;
      state.currentCall = null;
      state.currentCallUsedInPolicy = false;
    }
  },

  actions: {
    resetState({ commit }) {
      commit("RESET_STATE");
    },

    updateCurrentCall({ commit }, call) {
      commit("SET_CURRENT_CALL", call);
    },

    updateIvrActive({ commit }, isActive) {
      commit("SET_IVR_ACTIVE", isActive);
    },

    updateIvrLoaded({ commit }, isLoaded) {
      commit("SET_IVR_LOADED", isLoaded);
    },

    updateCurrentCallUsedInPolicy({ commit }, isUsed) {
      commit("SET_CURRENT_CALL_USED_IN_POLICY", isUsed);
    }
  },

  getters: {
    isIvrActive(state) {
      return state.ivrActive;
    },

    isOnCall(state) {
      return state.currentCall !== null;
    },

    currentCall(state) {
      return state.currentCall;
    },

    isIvrLoaded(state) {
      return state.ivrLoaded;
    },

    getCurrentUsedInPolicy(state) {
      return state.currentCallUsedInPolicy;
    }
  },
};
